export default function RepairNotReplace() {
  return (
    <section className="bg-plum py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto text-center">
          <p className="font-serif italic text-rose-200 text-sm md:text-base mb-3">
            Économique et écologique
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
            <span className="font-serif italic">Réparer</span> plutôt que remplacer la fenêtre
          </h2>
          <p className="text-base md:text-lg text-rose-100 leading-relaxed mb-8 max-w-2xl mx-auto">
            Remplacer une fenêtre entière parce qu'elle ne ferme plus bien, c'est jeter une menuiserie qui peut encore durer 20 ans. Le verre, le profilé, le dormant — tout est encore parfaitement viable. Ce qui lâche, ce sont les pièces mécaniques : les gonds, la crémone, les joints, les galets de compression. Chez DF PRO, nous remplaçons uniquement la pièce défectueuse et réajustons l'ensemble. Vous gardez votre fenêtre, votre isolation, votre esthétique, et vous économisez plusieurs centaines d'euros. C'est une réparation rapide, propre, et sans travaux lourds.
          </p>
          <a
            href="tel:0374471036"
            className="inline-flex items-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
          >
            <i className="ri-phone-line" />
            Appeler le 03 74 47 10 36
          </a>
        </div>
      </div>
    </section>
  );
}